The job ad ID to be updated.

This field is mandatory when updating a job ad.

Omit this field when creating a new job ad.
